export default "__VITE_ASSET__39635811__"